module.exports = __webpack_public_path__ + "images/9b224c9884c2bb081d4ac92b23675c2e.png";